// ACESSO-01 (L8a): a recusa do acesso novo, com a chave ACESSO_GRANULAR ligada (`EscopoDaAcao`). É um 403 com o
// `codigo` `escopo_ausente` (o escopo da ação que falta à pessoa), `concessao_recusada` (o que ela dá, e a quem, que
// não pode dar) ou `acao_fora_do_mapa` (a ação que não está no mapa de acesso, e que por isso ninguém faz), e a frase
// para gente em `error`, no idioma dela. Não tem `message` nem `mensagem`, e não desloga ninguém: a tela só precisa
// mostrar a frase. A ação fora do mapa entra também: fora desta lista, ela deixaria a lista de conversas carregando
// para sempre, como antes do L8a.
//
// Só a recusa: o `error` de outras respostas (o 401 do Pundit, o 404, o 422 do parâmetro que falta) é texto em inglês
// para quem depura, e a tela que hoje o troca por uma frase sua continua trocando.
const CODIGOS_DA_RECUSA = [
  'escopo_ausente',
  'concessao_recusada',
  'acao_fora_do_mapa',
];

// A frase da recusa num erro do axios, ou '' quando o erro é outro.
export const fraseDaRecusa = erro => {
  const { status, data } = erro?.response || {};
  if (status !== 403 || !CODIGOS_DA_RECUSA.includes(data?.codigo)) return '';
  return data.error || '';
};
